/**
 * Guarda os cinco UTMs da URL de entrada para quem grava lead em banco.
 *
 * O `campanha.ts` ao lado resolve outro problema: ele pega `utm_campaign`,
 * `gclid` e `fbclid` e os costura no TEXTO do WhatsApp, porque lá o lead chega
 * como conversa e a mensagem é o único carregador de origem. O formulário do
 * /wellness não passa por WhatsApp — o lead vira linha em `wellness_leads` —
 * então ele quer os UTMs como campos, e os cinco, não só a campanha.
 *
 * Captura no boot e não no submit porque a URL de entrada não sobrevive à
 * navegação: quem lê o QR cai em `/wellness?utm_source=...`, rola a página,
 * clica em âncora, e o `?utm_source` já saiu da barra antes de a pessoa
 * terminar de digitar o e-mail.
 */

export const CHAVES_UTM = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
] as const;

export type ChaveUtm = (typeof CHAVES_UTM)[number];
export type Utms = Partial<Record<ChaveUtm, string>>;

const PREFIXO = 'hw_';

/** Colar um valor gigante na URL não pode virar linha gigante no banco. */
const TAMANHO_MAXIMO = 150;

/** Chamar uma vez no boot, antes de qualquer navegação de rota. */
export function capturarUtms(): void {
  if (typeof window === 'undefined') return;

  try {
    const params = new URLSearchParams(window.location.search);
    for (const chave of CHAVES_UTM) {
      const valor = params.get(chave)?.trim();
      // Só sobrescreve se veio algo: uma segunda entrada sem UTM (digitou a URL
      // na mão, voltou do Instagram) não pode apagar a origem da primeira.
      if (valor) sessionStorage.setItem(PREFIXO + chave, valor.slice(0, TAMANHO_MAXIMO));
    }
  } catch {
    /* URL malformada ou storage bloqueado: o lead entra sem UTM */
  }
}

/** Devolve só as chaves que a visita realmente tem. */
export function lerUtms(): Utms {
  if (typeof window === 'undefined') return {};

  const utms: Utms = {};
  try {
    for (const chave of CHAVES_UTM) {
      const valor = sessionStorage.getItem(PREFIXO + chave);
      if (valor) utms[chave] = valor;
    }
  } catch {
    /* storage bloqueado */
  }
  return utms;
}
